import { render, staticRenderFns } from "./OrderControllerForm.vue?vue&type=template&id=f1ffb1b2&"
import script from "./OrderControllerForm.vue?vue&type=script&lang=js&"
export * from "./OrderControllerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports